var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodingChallengeHiconGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_1886)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_415_1886)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4128 1.8501C18.9559 1.85009 20.1658 1.85009 21.1382 1.92954C22.1284 2.01044 22.9464 2.1779 23.6868 2.55515C24.9039 3.17533 25.8935 4.16492 26.5137 5.3821C26.891 6.12249 27.0584 6.94049 27.1393 7.93065C27.2188 8.90299 27.2188 10.1128 27.2188 11.6559V11.7317C27.2188 13.2747 27.2188 14.4847 27.1393 15.457C27.0584 16.4472 26.891 17.2652 26.5137 18.0056C25.8935 19.2228 24.9039 20.2124 23.6868 20.8325C22.9464 21.2098 22.1284 21.3773 21.1382 21.4582C20.1659 21.5376 18.956 21.5376 17.4129 21.5376H14.8438V23.6008C15.5462 23.6499 16.2453 23.7605 16.9332 23.9324L18.7046 24.3753C19.1567 24.4883 19.4316 24.9464 19.3186 25.3985C19.2055 25.8506 18.7474 26.1254 18.2954 26.0124L16.5239 25.5695C15.6953 25.3624 14.8477 25.2588 14 25.2588C13.1523 25.2588 12.3047 25.3624 11.4761 25.5695L9.70464 26.0124C9.25256 26.1254 8.79446 25.8506 8.68144 25.3985C8.56842 24.9464 8.84328 24.4883 9.29536 24.3753L11.0668 23.9324C11.7547 23.7605 12.4538 23.6499 13.1562 23.6008V21.5376H10.5872C9.0441 21.5376 7.83415 21.5376 6.8618 21.4582C5.87164 21.3773 5.05365 21.2098 4.31325 20.8325C3.09608 20.2124 2.10648 19.2228 1.4863 18.0056C1.10905 17.2652 0.941588 16.4472 0.860689 15.457C0.781241 14.4847 0.781245 13.2748 0.78125 11.7316V11.6561C0.781245 10.1129 0.781241 8.90304 0.860689 7.93065C0.941588 6.94049 1.10905 6.12249 1.4863 5.3821C2.10648 4.16492 3.09608 3.17533 4.31325 2.55515C5.05365 2.1779 5.87164 2.01044 6.8618 1.92954C7.8342 1.85009 9.04406 1.85009 10.5872 1.8501H17.4128Z",
    fill: "#01EBD4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4128 1.8501C18.9559 1.85009 20.1658 1.85009 21.1382 1.92954C22.1284 2.01044 22.9464 2.1779 23.6868 2.55515C24.9039 3.17533 25.8935 4.16492 26.5137 5.3821C26.891 6.12249 27.0584 6.94049 27.1393 7.93065C27.2188 8.90299 27.2188 10.1128 27.2188 11.6559V11.7317C27.2188 13.2747 27.2188 14.4847 27.1393 15.457C27.0584 16.4472 26.891 17.2652 26.5137 18.0056C25.8935 19.2228 24.9039 20.2124 23.6868 20.8325C22.9464 21.2098 22.1284 21.3773 21.1382 21.4582C20.1659 21.5376 18.956 21.5376 17.4129 21.5376H14.8438V23.6008C15.5462 23.6499 16.2453 23.7605 16.9332 23.9324L18.7046 24.3753C19.1567 24.4883 19.4316 24.9464 19.3186 25.3985C19.2055 25.8506 18.7474 26.1254 18.2954 26.0124L16.5239 25.5695C15.6953 25.3624 14.8477 25.2588 14 25.2588C13.1523 25.2588 12.3047 25.3624 11.4761 25.5695L9.70464 26.0124C9.25256 26.1254 8.79446 25.8506 8.68144 25.3985C8.56842 24.9464 8.84328 24.4883 9.29536 24.3753L11.0668 23.9324C11.7547 23.7605 12.4538 23.6499 13.1562 23.6008V21.5376H10.5872C9.0441 21.5376 7.83415 21.5376 6.8618 21.4582C5.87164 21.3773 5.05365 21.2098 4.31325 20.8325C3.09608 20.2124 2.10648 19.2228 1.4863 18.0056C1.10905 17.2652 0.941588 16.4472 0.860689 15.457C0.781241 14.4847 0.781245 13.2748 0.78125 11.7316V11.6561C0.781245 10.1129 0.781241 8.90304 0.860689 7.93065C0.941588 6.94049 1.10905 6.12249 1.4863 5.3821C2.10648 4.16492 3.09608 3.17533 4.31325 2.55515C5.05365 2.1779 5.87164 2.01044 6.8618 1.92954C7.8342 1.85009 9.04406 1.85009 10.5872 1.8501H17.4128Z",
    stroke: "url(#paint0_linear_415_1886)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1562 17.3189C13.1562 17.7848 13.534 18.1626 14 18.1626L20.75 18.1626C21.216 18.1626 21.5937 17.7848 21.5937 17.3189C21.5937 16.8529 21.216 16.4751 20.75 16.4751L14 16.4751C13.534 16.4751 13.1562 16.8529 13.1562 17.3189ZM9.5 17.3189C9.5 17.9402 8.99632 18.4439 8.375 18.4439C7.75368 18.4439 7.25 17.9402 7.25 17.3189C7.25 16.6975 7.75368 16.1938 8.375 16.1938C8.99632 16.1938 9.5 16.6975 9.5 17.3189Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_415_1886",
    x: -23.9688,
    y: -22.8999,
    width: 75.9375,
    height: 73.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_415_1886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_415_1886",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_1886",
    x1: 0.78125,
    y1: 1.8501,
    x2: 24.888,
    y2: 28.1724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_1886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingChallengeHiconGlass);
export default __webpack_public_path__ + "static/media/CodingChallengeHiconGlass.db490c70e8ae306f5f47ff871d1450f6.svg";
export { ForwardRef as ReactComponent };